"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var functions_exports = {};
__export(functions_exports, {
  addRole: () => addRole,
  globalRoleLevel: () => globalRoleLevel,
  projectRoleLevel: () => projectRoleLevel,
  removeRole: () => removeRole,
  roleGt: () => roleGt,
  roleGte: () => roleGte,
  roleLt: () => roleLt,
  roleLte: () => roleLte,
  rolesAlike: () => rolesAlike,
  teamRoleLevel: () => teamRoleLevel,
  uniqRoles: () => uniqRoles,
  workspaceRoleLevel: () => workspaceRoleLevel
});
module.exports = __toCommonJS(functions_exports);
var import_util = require("@cartographerio/util");
var import_parse = require("./parse.js");
function compareRoles(func) {
  return (x, y) => {
    const [type1, name1, param1] = (0, import_parse.parseRole)(x);
    const [type2, name2, param2] = (0, import_parse.parseRole)(y);
    switch (type1) {
      case "G":
        return type2 === "G" ? func(globalRoleLevel(name1), globalRoleLevel(name2)) : void 0;
      case "W":
        return type2 === "W" && param1 === param2 ? func(workspaceRoleLevel(name1), workspaceRoleLevel(name2)) : void 0;
      case "P":
        return type2 === "P" && param1 === param2 ? func(projectRoleLevel(name1), projectRoleLevel(name2)) : void 0;
      case "T":
        return type2 === "T" && param1 === param2 ? func(teamRoleLevel(name1), teamRoleLevel(name2)) : void 0;
      default:
        return (0, import_util.checkExhausted)(type1);
    }
  };
}
const rolesAlike = compareRoles(() => true);
const roleGt = compareRoles((x, y) => x > y);
const roleGte = compareRoles((x, y) => x >= y);
const roleLte = compareRoles((x, y) => x <= y);
const roleLt = compareRoles((x, y) => x < y);
function addRole(roles, role, onConflict) {
  switch (onConflict) {
    case "replace":
      return removeRole(roles, role).concat([role]);
    case "keepBest":
      return uniqRoles([...roles, role]);
    default:
      return (0, import_util.checkExhausted)(onConflict);
  }
}
function removeRole(roles, role, alike = rolesAlike) {
  return roles.filter((r) => alike(r, role) !== true);
}
function uniqRoles(roles) {
  const ans = [];
  for (let i = 0; i < roles.length; i++) {
    const ri = roles[i];
    let foundBetter = false;
    for (let j = 0; j < roles.length; j++) {
      const rj = roles[j];
      if (i !== j && roleGt(rj, ri)) {
        foundBetter = true;
        break;
      }
    }
    if (!foundBetter) {
      ans.push(ri);
    }
  }
  return ans;
}
function globalRoleLevel(name) {
  switch (name) {
    case "MapViewer":
      return 0;
    case "Admin":
      return 1;
    case "Superuser":
      return 2;
    default:
      return (0, import_util.checkExhausted)(name);
  }
}
function workspaceRoleLevel(name) {
  switch (name) {
    case "Disabled":
      return 0;
    case "Active":
      return 1;
    case "Admin":
      return 2;
    case "Owner":
      return 3;
    default:
      return (0, import_util.checkExhausted)(name);
  }
}
function projectRoleLevel(name) {
  switch (name) {
    case "Member":
      return 0;
    case "Surveyor":
      return 1;
    case "Approver":
      return 2;
    case "Coordinator":
      return 3;
    default:
      return (0, import_util.checkExhausted)(name);
  }
}
function teamRoleLevel(name) {
  switch (name) {
    case "Member":
      return 0;
    case "Surveyor":
      return 1;
    case "Approver":
      return 2;
    case "Coordinator":
      return 3;
    default:
      return (0, import_util.checkExhausted)(name);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  addRole,
  globalRoleLevel,
  projectRoleLevel,
  removeRole,
  roleGt,
  roleGte,
  roleLt,
  roleLte,
  rolesAlike,
  teamRoleLevel,
  uniqRoles,
  workspaceRoleLevel
});
//# sourceMappingURL=functions.js.map
